import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import testimonyService from "../../api/testimonyService";

export const fetchTestimony = createAsyncThunk(
  "testimony/fetch",
  async ({ page = 1, length = 6 }, { rejectWithValue }) => {
    try {
      const response = await testimonyService.testimony({ page, length });
      const apiData = response.data;

      return {
        docs: apiData.docs || [],
        total: apiData.total || 0,
        page: apiData.page || 1,
        pages: apiData.pages || 1,
        length: apiData.length || length,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const initialState = {
  testimonyItems: [],
  total: 0,
  currentPage: 1,
  totalPages: 1,
  perPage: 6,

  isLoading: false,
  isError: false,
  errorMessage: "",
  hasInitialized: false,
};

const testimonySlice = createSlice({
  name: "testimony",
  initialState,
  reducers: {
    clearTestimony: (state) => {
      state.testimonyItems = [];
      state.hasInitialized = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestimony.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchTestimony.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasInitialized = true;
        state.isError = false;

        state.testimonyItems = action.payload.docs;
        state.total = action.payload.total;
        state.currentPage = action.payload.page;
        state.totalPages = action.payload.pages;
        state.perPage = action.payload.length;
      })
      .addCase(fetchTestimony.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.hasInitialized = true;
        state.errorMessage = action.payload || "Failed to load testimonials";
        state.testimonyItems = [];
      });
  },
});

export const { clearTestimony } = testimonySlice.actions;
export default testimonySlice.reducer;
